import { take, delay, call, put, cancel, fork } from 'redux-saga/effects';
import apiSaga from './apiSaga';
import { SUBMIT_ANSWER } from 'actionTypes';
import { submitAnswerSuccess } from 'actions';
import { isEmpty } from 'lodash';

const DEBOUNCE_TIME = 250;

function* delayedSubmitAnswerSaga(action) {
  // The delay allows us to cancel the task before we send the API request.
  yield delay(DEBOUNCE_TIME);
  let response = yield call(apiSaga, action, action.payload);
  if (isEmpty(response.errors)) {
    yield put(submitAnswerSuccess(response));
  }
}

function* submitAnswerSaga(action) {
  let previousTask;
  // We have to keep track of question ID so that answers to another question
  // do not cancel the task.
  let questionId;
  while (true) {
    const action = yield take(SUBMIT_ANSWER);
    const incomingQuestionId = action.endpointArgs.questionId;
    // If we are already trying to answer the same question, cancel the previous task.
    if (previousTask && incomingQuestionId === questionId) {
      yield cancel(previousTask);
    }
    previousTask = yield fork(delayedSubmitAnswerSaga, action);
    questionId = incomingQuestionId;
  }
}

export default [submitAnswerSaga()];



// WEBPACK FOOTER //
// ./src/sagas/answerSagas.js